module.exports = __webpack_public_path__ + "img/balance.ad72c95d.webp";